import type { HTMLAttributes, Ref } from "react";
import classNames from "classnames";
import styles from "./Separator.module.scss";

interface Props extends HTMLAttributes<HTMLDivElement> {
    orientation?: "horizontal" | "vertical";
    decorative?: boolean;
    block?: boolean;
}

const Separator = ({
    className,
    orientation = "horizontal",
    decorative = true,
    block,
    ref,
    ...props
}: Props & { ref?: Ref<HTMLDivElement> }) => (
    <div
        ref={ref}
        role={decorative ? "none" : "separator"}
        aria-orientation={decorative ? undefined : orientation}
        className={classNames(
            styles.separator,
            orientation === "horizontal" ? styles.horizontal : styles.vertical,
            block && styles.block,
            className,
        )}
        {...props}
    />
);

export { Separator };
